import { compactPrice, MarketplaceBadgeList, type MarketplaceBadgeDetail } from '@/components/warehouse/primitives'
import type { InventoryListItem, ProviderSlot, StorefrontPrice } from '@/lib/api/schemas/inventory.schema'
import { marketplaceBadges } from '@/lib/warehouse/projection'
import { YMARKET_PRICES_UNAVAILABLE_TEXT, ymarketPriceText } from '@/lib/warehouse/ymarket-storefront'

function targetForProvider(providerCode: string): StorefrontPrice['target'] | null {
  switch (providerCode) {
    case 'wildberries':
      return 'wildberries'
    case 'ymarket':
      return 'ymarket'
    case 'ozon':
      return 'ozon'
    case 'ori':
    case 'ori_site':
      return 'ori_site'
    default:
      return null
  }
}

function detailsFor(row: InventoryListItem, providerCodes: readonly string[]): MarketplaceBadgeDetail[] {
  return providerCodes.map((providerCode) => {
    const target = targetForProvider(providerCode)
    const price = target === null ? null : (row.storefrontPrices ?? []).find((candidate) => candidate.target === target) ?? null
    const readiness = target === null ? null : (row.storefrontReadiness ?? []).find((candidate) => candidate.target === target) ?? null
    if (target !== 'ymarket') return { providerCode, price, readiness }
    const priceText = ymarketPriceText(row.ymarketEconomics) ?? `Цена: ${compactPrice(price)} · ${YMARKET_PRICES_UNAVAILABLE_TEXT}`
    return { providerCode, price, readiness, priceText }
  })
}

export function StorefrontCompactCell({ row, providerSlots = null }: {
  row: InventoryListItem
  providerSlots?: readonly ProviderSlot[] | null
}) {
  const badges = marketplaceBadges(row, providerSlots)
  const details = detailsFor(row, badges.map((badge) => badge.providerCode))
  return (
    <span data-testid="storefronts-compact-cell" className="block min-w-max">
      <MarketplaceBadgeList badges={badges} compact details={details} />
    </span>
  )
}
